import React, { Component } from "react";
import "./logo.css";

export default class Logo extends Component {
  render() {
    return (
      <div className="logo col-md-12">
        <div className="imgLogo col-3 col-md-1 col-sm-4 col-xs-3">
          <img src={require("../../imagens/consultazap_logo.png")} />
          <h2 id="nomeLogo"> Logo </h2>
        </div>
        {/* <div className="form col-5 col-md-5 col-xs-5">
                    <form>
                        <input className="form-input" type="search" placeholder="Buscar&ensp;consultores... &#61442;"/>
                    </form>
                </div> */}
      </div>
    );
  }
}

export class LogoSimples extends Component {
  render() {
    return (
      <div className="simples-logo col-md-12">
        <img src={require("../../imagens/logo-banner.png")} />
        <h2 id="nomeLogo"> Logo </h2>
      </div>
    );
  }
}
